export const DOB_LABELS = {
  DATE_OF_BIRTH: 'Date of birth',
  BIRTH_YEAR: 'Birth year',
  DATE_OF_BIRTH_HELPER: 'MMDDYYYY',
  BIRTH_YEAR_HELPER: 'Enter 4 digits',
  SHOW_DATE_OF_BIRTH: 'Show date of birth'
};

export const DOB_ERROR_MSG = {
  required: 'Enter a date of birth',
  only_year_invalid: 'Enter a 4-digit year',
  future: 'Enter a date in the past',
  year_future: 'Enter a year in the past',
  date_invalid: 'Enter a valid date of birth',
  complete_dob: 'Enter a complete date of birth',
  real_dob: 'Enter a real date of birth',
  underage: 'Enter a date of birth at least 18 years in the past'
};

export const displayAlertMessage = (errMsg, translatedMessages = DOB_ERROR_MSG) => {
  if (!errMsg?.message) {
    return translatedMessages?.complete_dob || DOB_ERROR_MSG.complete_dob;
  }

  return errMsg.message.toString();
};
